import {Text} from 'platform/foundation';

import {ReactNode} from 'react';

import {isNil} from 'ramda';

import {suffixTestId, TestIdProps} from 'shared/web';

interface FooterLinkProps extends TestIdProps {
  children: ReactNode;
  href?: string;
}

export function FooterLink(props: FooterLinkProps) {
  if (isNil(props.href)) {
    return null;
  }

  return (
    <a href={props.href} target="_blank" rel="noreferrer" data-testid={suffixTestId('link', props)}>
      <Text color="secondary">{props.children}</Text>
    </a>
  );
}
